webpackJsonp([254572558124955],{

/***/ 900:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"algolia":{"appId":"1ABU4N544C","searchOnlyApiKey":"44eb42733115ebe1c03bf5fa40b775fb","indexName":"oyabi.fr"}}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---search-8f94c7acc3f33192fc48.js